import type { FaireProductEntity } from "../../entity_types/product";

export const p_5s87fkcwdv: FaireProductEntity = {
  token: "p_5s87fkcwdv",
  type: "product",
  name: "3pc - 1Pack White Sage Smudge Sticks with Strong Aroma",
  brandToken: "b_9jg4fbzgpg",
  brandName: "Like International",
  imageUrl:
    "https://cdn.faire.com/fastly/e6013523ebdec62fde9158d5b529b9fe0ae3321551924871598704d28178df7e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/64f8b10f1b360d1489f328e65299a2c003624b9f59e4207d59d3b9d8df401726.jpeg",
    "https://cdn.faire.com/fastly/0e1a442c32dac1d9856ea70dfe77f5828c90f3acce59b12379f46e747d5fa328.jpeg",
    "https://cdn.faire.com/fastly/71f0fd8cfe60bb32f52a7054eac7865d0c02640fef022cec926b0cfdf3742b31.jpeg",
    "https://cdn.faire.com/fastly/dc64b5cea5953eb43e4017a93fecc416fd3832092612a3d0353683ad2953461c.jpeg",
    "https://cdn.faire.com/fastly/b54dcdf9580bbba9bf5ef0733033aee5532090fdf6d325facb1e43f5f3df79b4.jpeg",
    "https://cdn.faire.com/fastly/4fe1e8f1e4b2cbe270fd84013a33d283d211de538761ac4ee8055c8b25fc390d.jpeg",
    "https://cdn.faire.com/fastly/b08f0b814e7af35703c6ab58bdbbd13896770ca65e06bccb4189d011083712cf.jpeg",
    "https://cdn.faire.com/fastly/957dd0bd7fe472d9a6e708e5ccbc07de4b635ddc31975a6a9db02cd5cfa3318a.jpeg",
  ],
  priceDollars: 6.93,
  description:
    'Our sage smudgesticks are the perfect fit for you, whether you\'re a sage pro or a beginner. Fresh and hand-tied, our bundles will leave your home surrounded with good vibes and a fresh, sage-y aroma!  o\n\nSome of our bundles are actually homegrown and harvested, which makes them super fresh and fragrant. Our large sage plants produce a good amount of sage, which we love to use to provide our customers with the best sage we can find.\n\nSage is used to leave your home smelling fragrant and fresh and is also believed by many to have healing and spiritual benefits. It is said that burning sage in your home will being prosperity and wisdom to your home and anyone in your household.\n\nOur bundles of sage are each approximately 8" and are perfect for any sage beginner or sage pro! I appreciate your support! :)\nHomegrown jumbo 8" ca white sage smudge sticks homegrown and harvested strong lasting aroma scent incense scented candles spiritual',
  tags: [],
  msrpDollars: 20.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:20.330Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
